<template>
  <DialogLayout class="plat-class-teacher-distribute-class"
                v-loading="loading"
                element-loading-text="数据加载中，请稍等...">
    <div v-if="gradeNames && gradeNames.length"
         class="distribute-class-cont">
      <div class="alert">
        <div class="title">
          <i class="el-icon-warning-outline"></i>
          <span>不勾选任何班级则默认拥有所有班级的权限</span>
        </div>
        <div class="extra">
          <span v-if="checkedIds.length">已选择<span class="theme-text">{{checkedIds.length}}</span>个班级</span>
          <span v-else>暂未勾选班级</span>
        </div>
      </div>
      <AppScrollbar style="height: 100%"
                    v-loading="committing"
                    element-loading-text="数据提交中，请稍等...">
        <div class="distribute-cont">
          <PlatClassTeacherDistributeClassGrade v-for="gradeName in gradeNames"
                                                :key="gradeName"
                                                v-model="checked[gradeName]"
                                                :grade-name="gradeName"
                                                :grade="gradeList[gradeName]">
          </PlatClassTeacherDistributeClassGrade>
        </div>
      </AppScrollbar>
    </div>
    <template v-else>
      <Hint v-if="!loading"
            type="empty">
        <span>没有可分配的班级</span>
      </Hint>
    </template>
    <template v-if="gradeNames && gradeNames.length"
              #footer>
      <el-button size="mini"
                 type="primary"
                 :disabled="committing"
                 @click="handleApply">提交设置</el-button>
      <el-button size="mini"
                 type="default"
                 @click="handleClose">取消操作</el-button>
    </template>
  </DialogLayout>
</template>

<script>
import DialogLayout from '../../../../../../../widgets/DialogLayout'
import AppScrollbar from '../../../../../../../elements/AppScrollbar'
import PlatClassTeacherDistributeClassGrade from './grade'
import Hint from '../../../../../../../elements/Hint'
export default {
  name: 'PlatClassTeacherDistributeClass',
  components: {
    DialogLayout,
    AppScrollbar,
    PlatClassTeacherDistributeClassGrade,
    Hint
  },
  props: {
    rowData: {
      type: Object,
      required: true
    },
    visible: Boolean
  },
  data () {
    return {
      loading: false,
      classes: [],
      classIds: [],
      checked: {},
      committing: false
    }
  },
  computed: {
    gradeList () {
      let classes = this.classes
      let grades = {}
      if (classes) {
        classes.forEach(clazz => {
          let grade = grades[clazz.gradeName] || (grades[clazz.gradeName] = {id: clazz.gradeId, clazzList: []})
          grade.clazzList.push(clazz)
        })
      }
      return grades
    },
    gradeNames () {
      let gradeList = this.gradeList
      if (gradeList) {
        let gradeNames = Object.keys(gradeList)
        gradeNames.sort((o1, o2) => o1 > o2 ? -1 : 1)
        return gradeNames
      }
    },
    checkedIds () {
      return Object.values(this.checked).reduce((p, v) => {
        if (v && v.length) {
          return p.concat(v)
        } else {
          return p
        }
      }, [])
    }
  },
  methods: {
    loadDistributeInfo () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/plat/management/peClassTeacher/distributeClass',
        method: 'post',
        data: this.$qs.stringify({
          postId: this.rowData.id
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              let distributeClass = response.data['distributeClass'] || {}
              this.classes = distributeClass['classes'] || []
              this.classIds = distributeClass['classIds'] || []
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    handleApply () {
      let checkedIds = this.checkedIds
      let classIds = this.classIds || []
      let addClassIds = []
      let delClassIds = []
      checkedIds.forEach(classId => {
        if (!classIds.includes(classId)) {
          addClassIds.push(classId)
        }
      })
      classIds.forEach(id => {
        if (!checkedIds.includes(id)) {
          delClassIds.push(id)
        }
      })
      if (addClassIds.length === 0 && delClassIds.length === 0) {
        this.$message.warning('配置未发生变化')
        return
      }
      this.committing = true
      this.$ajax({
        url: '/workspace/manager/plat/management/peClassTeacher/submitDistributeClass',
        method: 'post',
        data: this.$qs.stringify({
          postId: this.rowData.id,
          addClassIds: addClassIds,
          delClassIds: delClassIds
        }, {
          arrayFormat: 'repeat'
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message.success(response.data['message'])
              this.$nextTick(() => {
                this.classIds = checkedIds
                this.$emit('hidePopover')
              })
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.committing = false
      })
    },
    handleClose () {
      this.$emit('hidePopover')
    }
  },
  mounted () {
    this.loadDistributeInfo()
  },
  watch: {
    gradeList: function (grades) {
      let classIds = this.classIds
      Object.keys(grades).forEach(gradeName => {
        this.$set(this.checked, gradeName, grades[gradeName].clazzList
          .filter(clazz => classIds.includes(clazz.id))
          .map(clazz => clazz.id))
      })
    },
    visible: function (val) {
      if (val) {
        this.loadDistributeInfo()
      }
    }
  }
}
</script>

<style lang="scss">
  .plat-class-teacher-distribute-class {
    .distribute-class-cont {
      height: 100%;
      padding-top: 36px;
      box-sizing: border-box;
      .alert {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        height: 36px;
        line-height: 36px;
        font-size: 12px;
        padding: 0 15px;
        background-color: #fdf8e8;
        display: flex;
        justify-content: space-between;
        align-items: center;
        & > .title {
          color: #e6a23c;
          i {
            margin-right: 2px;
            font-size: 14px;
            vertical-align: -1px;
          }
        }
        & > .extra {
          color: #606266;
          span {
            margin-left: 2px;
            margin-right: 2px;
          }
        }
      }
      .distribute-cont {
        padding: 15px;
        box-sizing: border-box;
      }
    }
  }
</style>
